export const quotationsData = [
  {
    key: "1",
    CUSTOMER_IMG: "customer-01.jpg",
    CUSTOMER: "Reuben Keen ",
    BADGE: "Client",
    CAR_IMG: "car-01.jpg",
    CAR: "Ford Endeavour",
    CAR_TYPE: "Sedan",
    PICK_UP_DETAILS: "12",
    PICK_UP_LOCATION: "Newyork",
    DROP_OFF_DETAILS: "13",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "2",
    PRICE: "$120",
    STATUS: "Approved",
  },
  {
    key: "2",
    CUSTOMER_IMG: "customer-02.jpg",
    CUSTOMER: "William Jones",
    BADGE: "Company",
    CAR_IMG: "car-02.jpg",
    CAR: "Ferrari 458 MM",
    CAR_TYPE: "Convertible",
    PICK_UP_DETAILS: "12",
    PICK_UP_LOCATION: "Newyork",
    DROP_OFF_DETAILS: "13",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "3",
    PRICE: "$140",
    STATUS: "Approved",
  },
  {
    key: "3",
    CUSTOMER_IMG: "customer-03.jpg",
    CUSTOMER: "Leonard Jandreau",
    BADGE: "Company",
    CAR_IMG: "car-03.jpg",
    CAR: "Ford Mustang",
    CAR_TYPE: "Coupe",
    PICK_UP_DETAILS: "14",
    PICK_UP_LOCATION: "Los Angeles",
    DROP_OFF_DETAILS: "15",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "4",
    PRICE: "$200",
    STATUS: "Approved",
  },
  {
    key: "4",
    CUSTOMER_IMG: "customer-04.jpg",
    CUSTOMER: "Adam Bolden",
    BADGE: "Client",
    CAR_IMG: "car-04.jpg",
    CAR: "Toyota Tacoma 4",
    CAR_TYPE: "Hatchback",
    PICK_UP_DETAILS: "14",
    PICK_UP_LOCATION: "Houston",
    DROP_OFF_DETAILS: "14",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "2",
    PRICE: "$210",
    STATUS: "Approved",
  },
  {
    key: "5",
    CUSTOMER_IMG: "customer-05.jpg",
    CUSTOMER: "Harvey Jimenez",
    BADGE: "Company",
    CAR_IMG: "car-05.jpg",
    CAR: "Chevrolet Truck",
    CAR_TYPE: "Sedan",
    PICK_UP_DETAILS: "14",
    PICK_UP_LOCATION: "Phoenix",
    DROP_OFF_DETAILS: "15",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "4",
    PRICE: "$180",
    STATUS: "Rejected",
  },
  {
    key: "6",
    CUSTOMER_IMG: "customer-06.jpg",
    CUSTOMER: "William Ward",
    BADGE: "Client",
    CAR_IMG: "car-06.jpg",
    CAR: "Etios Carmen",
    CAR_TYPE: "Hatchback",
    PICK_UP_DETAILS: "14",
    PICK_UP_LOCATION: "Philadelphia",
    DROP_OFF_DETAILS: "15",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "2",
    PRICE: "$160",
    STATUS: "Approved",
  },
  {
    key: "7",
    CUSTOMER_IMG: "customer-07.jpg",
    CUSTOMER: "Norman Coleman",
    BADGE: "Client",
    CAR_IMG: "car-07.jpg",
    CAR: "Acura Sport",
    CAR_TYPE: "Crossover",
    PICK_UP_DETAILS: "14",
    PICK_UP_LOCATION: "Philadelphia",
    DROP_OFF_DETAILS: "15",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "1",
    PRICE: "$150",
    STATUS: "Approved",
  },
  {
    key: "8",
    CUSTOMER_IMG: "customer-08.jpg",
    CUSTOMER: "Jay Beckman",
    BADGE: "Company",
    CAR_IMG: "car-08.jpg",
    CAR: "Kia Soul 2016",
    CAR_TYPE: "Delivery",
    PICK_UP_DETAILS: "04",
    PICK_UP_LOCATION: "Philadelphia",
    DROP_OFF_DETAILS: "06",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "2",
    PRICE: "$200",
    STATUS: "Rejected",
  },
  {
    key: "9",
    CUSTOMER_IMG: "customer-09.jpg",
    CUSTOMER: "Francis Harris",
    BADGE: "Client",
    CAR_IMG: "car-09.jpg",
    CAR: "Camaro",
    CAR_TYPE: "Station Wagon",
    PICK_UP_DETAILS: "04",
    PICK_UP_LOCATION: "Philadelphia",
    DROP_OFF_DETAILS: "06",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "4",
    PRICE: "$140",
    STATUS: "Rejected",
  },
  {
    key: "10",
    CUSTOMER_IMG: "customer-10.jpg",
    CUSTOMER: "Renaldo Labarre",
    BADGE: "Company",
    CAR_IMG: "car-10.jpg",
    CAR: "Toyota Camry",
    CAR_TYPE: "Mini Van",
    PICK_UP_DETAILS: "04",
    PICK_UP_LOCATION: "Philadelphia",
    DROP_OFF_DETAILS: "06",
    DROP_OFF_LOCATION: "Newyork",
    PASSENGERS: "3",
    PRICE: "$170",
    STATUS: "Approved",
  },
];
